import styled from "@emotion/styled";
import { Box } from "@chakra-ui/react";
import { customEvent, getCdnImageSrc } from "goi_common";
import { BaseStack } from "goi_common/src/design-system";
import Image from "next/image";
import { Series } from "../constants/contentData";

interface ContentSeriesSectionProps {
  series: Series;
}

export default function ContentSeriesSection({
  series,
}: ContentSeriesSectionProps) {
  return (
    <BaseStack spacing={16} pt={24} pb={24}>
      <Box px="20px" className="headline_2_sb" style={{ color: "#171819" }}>
        {series.title}
      </Box>
      <CardScrollRow>
        {series.cards.map((card) => (
          <CardWrapper
            key={card.id}
            href={card.href}
            target={card.href.startsWith("http") ? "_blank" : undefined}
            rel={
              card.href.startsWith("http") ? "noopener noreferrer" : undefined
            }
            onClick={() => {
              customEvent({
                newGtm: {
                  path: "content",
                  trigger_and_target: `uv_feed-${card.id}`,
                },
              });
            }}
          >
            <BaseStack spacing={10}>
              <Box
                position="relative"
                width="280px"
                height="161px"
                borderRadius="10.5px"
                overflow="hidden"
                background={card.thumbnailBg}
                style={{ flexShrink: 0 }}
              >
                {card.thumbnailSrc && (
                  <Image
                    src={getCdnImageSrc(card.thumbnailSrc)}
                    alt={card.title}
                    fill
                    style={{ objectFit: "cover" }}
                  />
                )}
              </Box>
              <BaseStack spacing={6}>
                <Box
                  style={{
                    color: "#171819",
                    fontSize: "18px",
                    fontWeight: 600,
                    lineHeight: "26px",
                    letterSpacing: "-0.36px",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {card.title}
                </Box>
                <Box
                  style={{
                    color: "#46494c",
                    fontSize: "16px",
                    fontWeight: 400,
                    lineHeight: "24px",
                    letterSpacing: "-0.1px",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {card.description}
                </Box>
                <Box style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                  {card.tags.map((tag) => (
                    <Box
                      key={tag}
                      style={{
                        background: "#ffffff",
                        border: "1px solid #dddedf",
                        borderRadius: "4px",
                        padding: "4px 6px",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#46494c",
                        lineHeight: "16px",
                        letterSpacing: "-0.1px",
                      }}
                    >
                      {tag}
                    </Box>
                  ))}
                </Box>
              </BaseStack>
            </BaseStack>
          </CardWrapper>
        ))}
      </CardScrollRow>
    </BaseStack>
  );
}

const CardScrollRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  overflow-x: auto;
  padding: 0 20px;
  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

const CardWrapper = styled.a`
  display: block;
  flex-shrink: 0;
  width: 280px;
  text-decoration: none;
  color: inherit;
`;
